import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const VCS_AGENT_POOL_AGENTS_TABLE_STORAGE_KEY = "vcsAgentPoolAgentsTableStorageKey";
export const VCS_AGENT_POOL_AGENTS_TABLE_FILTERS_STORAGE_KEY =
  "vcsAgentPoolAgentsTableFiltersStorageKey";

export enum VCS_AGENT_POOL_AGENTS_COLUMN_ID {
  AGENT_ID = "AGENT_ID",
  METADATA = "METADATA",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;

export const VCS_AGENT_POOL_AGENTS_TABLE_COLUMNS_CONFIG: Record<
  VCS_AGENT_POOL_AGENTS_COLUMN_ID,
  TableColumnMeta
> = {
  [VCS_AGENT_POOL_AGENTS_COLUMN_ID.AGENT_ID]: {
    id: VCS_AGENT_POOL_AGENTS_COLUMN_ID.AGENT_ID,
    title: "Agent ID",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [VCS_AGENT_POOL_AGENTS_COLUMN_ID.METADATA]: {
    id: VCS_AGENT_POOL_AGENTS_COLUMN_ID.METADATA,
    title: "Metadata",
    minWidth: 200,
    defaultWidth: 400,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    configurable: true,
  },
  [VCS_AGENT_POOL_AGENTS_COLUMN_ID.DROPDOWN]: {
    id: VCS_AGENT_POOL_AGENTS_COLUMN_ID.DROPDOWN,
    title: "Table configuration",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<VCS_AGENT_POOL_AGENTS_COLUMN_ID, string> = {
  [VCS_AGENT_POOL_AGENTS_COLUMN_ID.AGENT_ID]: "agentId",
  [VCS_AGENT_POOL_AGENTS_COLUMN_ID.METADATA]: "metadata",
  [VCS_AGENT_POOL_AGENTS_COLUMN_ID.DROPDOWN]: "dropdown",
};

/** Matches `useTableSort` / URL: sort key is the encoded column field (`SORT_CONFIG` value), not the column id. */
export const INITIAL_SORT_OPTION = SORT_CONFIG[VCS_AGENT_POOL_AGENTS_COLUMN_ID.AGENT_ID];
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;
